var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgP13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0007 28H24.6673C23.9309 28 23.334 27.4031 23.334 26.6667V13.3333C23.334 12.597 23.9309 12 24.6673 12H26.0007C26.7371 12 27.334 12.597 27.334 13.3333V26.6667C27.334 27.4031 26.7371 28 26.0007 28Z",
    stroke: "#F63C47",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 4H26V8",
    stroke: "#F63C47",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3333 4.66666C25.3333 4.66666 20 11.3333 6 16",
    stroke: "#F63C47",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 28H15.3333C14.5969 28 14 27.4031 14 26.6667V18C14 17.2636 14.5969 16.6667 15.3333 16.6667H16.6667C17.4031 16.6667 18 17.2636 18 18V26.6667C18 27.4031 17.4031 28 16.6667 28Z",
    stroke: "#F63C47",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33268 28H5.99935C5.26298 28 4.66602 27.4031 4.66602 26.6667V21.3333C4.66602 20.5969 5.26298 20 5.99935 20H7.33268C8.06906 20 8.66602 20.5969 8.66602 21.3333V26.6667C8.66602 27.4031 8.06906 28 7.33268 28Z",
    stroke: "#F63C47",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP13);
export default __webpack_public_path__ + "static/media/p13.fef3dee323ed1eb7de6c21d41cfe4262.svg";
export { ForwardRef as ReactComponent };